module.exports = __webpack_public_path__ + "img/purple-hair-doc-female.77d7f18c.png";